/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareClassEnum } from './share-class-enum';
import { InvestmentExportStatusEnum } from './investment-export-status-enum';

export interface PatchedInvestmentsExportRequest {
  status?: InvestmentExportStatusEnum;
  allocation_date?: string;
  share_class?: ShareClassEnum;
  share_price?: string;
}
export namespace PatchedInvestmentsExportRequest {}
